<div class="flex flex-col space-y-4" *transloco="let t; read: 'expression-settings'">
  <div class="flex flex-col space-y-6 p-4 border rounded-sm shadow-sm bg-gray-50">

    <div class="flex flex-col space-y-2" *ngFor="let expression of predicate.expressions; let i = index">
      <span class="py-2 font-bold" *ngIf="i > 0">{{t("OPERATOR_OR")}}</span>

      <div class="flex flex-col space-y-2">

        <div class="flex flex-col" *ngFor="let condition of expression.conditions; let ci = index">

          <div class="flex flex-col space-y-2">

            <span class="py-2 font-bold" *ngIf="ci > 0">{{t("OPERATOR_AND")}}</span>
            <div class="flex flex-row items-center space-x-2 p-0">
              <mat-form-field class="w-60 fuse-mat-dense-subscript">
                <mat-select [(value)]="condition.field">
                  <mat-option [value]="field"
                              *ngFor="let field of getAvailableFields(condition, expression)">{{field.label}}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="min-w-40 fuse-mat-dense-subscript" *ngIf="condition.field">
                <mat-select [(value)]="condition.operator">
                  <mat-option [value]="operator"
                              *ngFor="let operator of condition.field.type.supportedComparisonOperators()">{{getOperatorText(condition.field, operator)}}</mat-option>
                </mat-select>
              </mat-form-field>

              <ng-container *ngIf="condition.field && condition.operator && getComparatorPicker(condition) as picker">
                <ng-container [ngSwitch]="picker.type">
                  <ng-container *ngSwitchCase="'text'">
                    <mat-form-field class="w-60 fuse-mat-dense-subscript">
                      <input required matInput [(ngModel)]="condition.value"/>
                    </mat-form-field>
                  </ng-container>

                  <ng-container *ngSwitchCase="'selection'">
                    <mat-form-field class="w-60 fuse-mat-dense-subscript">
                      <mat-select required [(value)]="condition.value">
                        <mat-option [value]="v.value" *ngFor="let v of picker.values">{{v.text}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-container>
                  <ng-container *ngSwitchCase="'number'">
                    <mat-form-field class="w-60 fuse-mat-dense-subscript">
                      <input type="number" required matInput [(ngModel)]="condition.value"/>
                    </mat-form-field>
                  </ng-container>
                  <ng-container *ngSwitchCase="'cid10-selection'">
                    <cid10-picker class="w-60" [(value)]="condition.value"></cid10-picker>
                  </ng-container>
                </ng-container>
              </ng-container>

              <button mat-icon-button (click)="removeCondition(expression, condition)">
                <mat-icon svgIcon="heroicons_solid:trash"></mat-icon>
              </button>

            </div>
          </div>

        </div>

        <button class="self-start" mat-button color="primary" (click)="newCondition(expression)">
          {{t("ACTION_ADD_EXPRESSION_CONDITION")}}
        </button>

      </div>

    </div>

    <button class="self-start" mat-stroked-button (click)="add()">
      {{t("ACTION_ADD_PREDICATE_EXPRESSION")}}
    </button>

  </div>

</div>

